/* Dive Centre Bondi — AJAX cart, drawer, predictive search, variant swap.
   Single inline-loaded module. No deps. */
(function () {
  'use strict';

  // ---------- Helpers ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  // Format cents using Shopify's money_format string (e.g. ${{amount}}, ${{amount_with_comma_separator}}).
  // Falls back to a $X.XX rendering if no format is provided.
  function money(cents) {
    var fmt = (window.__diveShop && window.__diveShop.money_format) || '${{amount}}';
    var amount = cents / 100;
    function fmtNum(opts) {
      var precision = opts.precision != null ? opts.precision : 2;
      var thousands = opts.thousands || ',';
      var decimal   = opts.decimal   || '.';
      var n = (Math.round(amount * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return parts[1] != null ? parts.join(decimal) : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount':                                  return fmtNum({ precision: 2, thousands: ',', decimal: '.' });
        case 'amount_no_decimals':                      return fmtNum({ precision: 0, thousands: ',', decimal: '.' });
        case 'amount_with_comma_separator':             return fmtNum({ precision: 2, thousands: '.', decimal: ',' });
        case 'amount_no_decimals_with_comma_separator': return fmtNum({ precision: 0, thousands: '.', decimal: ',' });
        case 'amount_with_apostrophe_separator':        return fmtNum({ precision: 2, thousands: "'", decimal: '.' });
        case 'amount_with_space_separator':             return fmtNum({ precision: 2, thousands: ' ', decimal: '.' });
        default: return fmtNum({ precision: 2, thousands: ',', decimal: '.' });
      }
    });
  }
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    if (opts.body && typeof opts.body !== 'string' && !(opts.body instanceof FormData)) {
      opts.body = JSON.stringify(opts.body);
      opts.headers['Content-Type'] = 'application/json';
    }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw Object.assign(new Error('Cart error'), { data: data, status: r.status });
        return data;
      });
    });
  }

  // ---------- Cart drawer refresh ----------
  function openCartDrawer() {
    var t = document.querySelector('.dh__cart-toggle');
    if (t) t.checked = true;
  }
  function closeCartDrawer() {
    var t = document.querySelector('.dh__cart-toggle');
    if (t) t.checked = false;
  }

  function refreshCartUI() {
    return fetchJSON('/cart.js').then(function (cart) {
      // Update count badge
      var iconBtn = document.querySelector('.dh__icon-btn[for$="-cart"]');
      if (iconBtn) {
        var existing = iconBtn.querySelector('.dh__cart-badge');
        if (cart.item_count > 0) {
          if (!existing) {
            existing = document.createElement('span');
            existing.className = 'dh__cart-badge';
            existing.style.cssText = 'position:absolute;top:-2px;right:-2px;background:#E14B4B;color:#FFF;font-size:10px;font-weight:700;border-radius:999px;padding:2px 5px;min-width:16px;height:16px;display:grid;place-items:center;line-height:1;';
            iconBtn.appendChild(existing);
          }
          existing.textContent = cart.item_count;
        } else if (existing) {
          existing.remove();
        }
      }

      // Rebuild drawer body + footer
      var head = document.querySelector('.dh__cart-head h2');
      if (head) head.innerHTML = 'Your cart' + (cart.item_count > 0 ? ' <span style="font-weight:400;color:rgba(1,7,14,0.55);">(' + cart.item_count + ')</span>' : '');

      var body = document.querySelector('.dh__cart-body');
      var existingFoot = document.querySelector('.dh__cart-foot');
      if (existingFoot) existingFoot.remove();
      if (!body) return cart;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="dh__cart-empty">'
          + '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 7h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>'
          + '<p>Your cart is empty.</p>'
          + '<a class="dh__cart-cta" href="/collections/all">Start shopping</a>'
          + '</div>';
      } else {
        var html = '';
        cart.items.forEach(function (item) {
          var img = item.image
            ? '<img class="dh__cart-item-img" src="' + (item.image.replace('_180x180.', '_200x200.') ) + '" alt="">'
            : '<div class="dh__cart-item-img"></div>';
          var variant = (item.variant_options && item.variant_options.length > 0 && item.variant_title && !item.variant_title.includes('Default'))
            ? '<p class="dh__cart-item-variant">' + item.variant_title + '</p>' : '';
          html += '<div class="dh__cart-item" data-line="' + item.key + '">'
            + img
            + '<div>'
              + '<a class="dh__cart-item-title" href="' + item.url + '">' + item.product_title + '</a>'
              + variant
              + '<div style="display:inline-flex;align-items:center;border:1px solid rgba(1,7,14,.10);border-radius:999px;margin-top:8px;">'
                + '<button type="button" class="dh-cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" style="width:28px;height:28px;border:0;background:transparent;cursor:pointer;color:#01070E;">−</button>'
                + '<span style="min-width:28px;text-align:center;font-size:13px;font-weight:600;">' + item.quantity + '</span>'
                + '<button type="button" class="dh-cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" style="width:28px;height:28px;border:0;background:transparent;cursor:pointer;color:#01070E;">+</button>'
              + '</div>'
            + '</div>'
            + '<p class="dh__cart-item-price">' + money(item.final_line_price) + '</p>'
            + '</div>';
        });
        body.innerHTML = html;

        var foot = document.createElement('div');
        foot.className = 'dh__cart-foot';
        foot.innerHTML = '<div class="dh__cart-row dh__cart-row--total">'
          + '<span>Subtotal</span><span>' + money(cart.total_price) + '</span>'
          + '</div>'
          + '<p style="font-size:12px;color:rgba(1,7,14,0.55);margin:0 0 14px;">Shipping and taxes calculated at checkout.</p>'
          + '<a class="dh__cart-checkout" href="/checkout">Checkout</a>'
          + '<a class="dh__cart-view" href="/cart">View cart</a>';
        var drawer = document.querySelector('.dh__cart-drawer');
        if (drawer) drawer.appendChild(foot);
      }
      return cart;
    });
  }

  // ---------- Add to cart ----------
  function bindAtcForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { return refreshCartUI(); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = '✓ Added'; setTimeout(function () { btn.innerHTML = originalText; }, 1200); }
          // Do NOT open the theme's built-in cart drawer here — iCart (or any installed cart drawer app)
          // should be the one that pops open. We fire common event names that most third-party cart apps listen for.
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e) {}
          try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch(e) {}
          try { document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true })); } catch(e) {}
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
          alert((err && err.description) || 'Could not add to cart.');
        });
    });
  }

  // ---------- Cart qty change ----------
  function bindCartQtyChange() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dh-cart-qty-btn');
      if (!btn) return;
      e.preventDefault();
      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      if (isNaN(qty) || qty < 0) return;
      btn.disabled = true;
      fetchJSON('/cart/change.js', { method: 'POST', body: { id: key, quantity: qty } })
        .then(function () { return refreshCartUI(); })
        .catch(function () { btn.disabled = false; });
    });
  }

  // ---------- Variant swap on product page ----------
  function initVariantSwap() {
    var pdp = document.querySelector('.dive-pdp');
    if (!pdp) return;
    var variantData = window.__diveVariants;
    if (!variantData) return;

    var idInput = pdp.querySelector('input[name="id"]');
    var priceEl = pdp.querySelector('.dpdp__price');
    var compareEl = pdp.querySelector('.dpdp__compare');
    var saveEl = pdp.querySelector('.dpdp__save');
    var atcBtn = pdp.querySelector('.dpdp__atc');
    var heroImg = pdp.querySelector('.dpdp__hero-img img');
    var thumbs = $$('.dpdp__thumb', pdp);

    function readSelections() {
      var values = [];
      $$('.dpdp__opt', pdp).forEach(function (opt) {
        var sel = opt.querySelector('.dpdp__swatch--sel, .dpdp__size--sel');
        if (sel) values.push(sel.title || sel.textContent.trim());
      });
      return values;
    }

    function findVariant(values) {
      return variantData.find(function (v) {
        if (!v.options) return false;
        return v.options.every(function (o, i) { return values[i] && o.toLowerCase() === values[i].toLowerCase(); });
      });
    }

    function updateLabelValues() {
      $$('.dpdp__opt', pdp).forEach(function (opt) {
        var sel = opt.querySelector('.dpdp__swatch--sel, .dpdp__size--sel');
        var label = opt.querySelector('.dpdp__opt-label .v');
        if (sel && label) label.textContent = sel.title || sel.textContent.trim();
      });
    }

    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) {
            var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            saveEl.textContent = '−' + pct + '%';
            saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        if (v.available) { atcBtn.disabled = false; atcBtn.textContent = 'Add to Cart'; }
        else            { atcBtn.disabled = true;  atcBtn.textContent = 'Sold out'; }
      }
      if (v.featured_image && heroImg) {
        heroImg.src = v.featured_image.replace(/_(\d+)x(\d+)\./, '_1400x1400.');
        // also highlight matching thumbnail
        thumbs.forEach(function (t) {
          var img = t.querySelector('img');
          if (!img) return;
          var match = img.src && v.featured_image && img.src.indexOf(v.featured_image.split('?')[0].split('/').pop().split('_')[0]) > -1;
          t.classList.toggle('dpdp__thumb--sel', !!match);
        });
      }
    }

    pdp.addEventListener('click', function (e) {
      var sw = e.target.closest('.dpdp__swatch, .dpdp__size');
      if (!sw) return;
      var opt = sw.closest('.dpdp__opt');
      if (!opt) return;
      $$('.dpdp__swatch--sel, .dpdp__size--sel', opt).forEach(function (el) { el.classList.remove('dpdp__swatch--sel', 'dpdp__size--sel'); });
      sw.classList.add(sw.classList.contains('dpdp__swatch') ? 'dpdp__swatch--sel' : 'dpdp__size--sel');
      updateLabelValues();
      var v = findVariant(readSelections());
      applyVariant(v);
    });

    // Thumb click swap
    pdp.addEventListener('click', function (e) {
      var th = e.target.closest('.dpdp__thumb');
      if (!th) return;
      var img = th.querySelector('img');
      if (img && heroImg) {
        heroImg.src = img.src.replace(/_(\d+)x(\d+)\./, '_1400x1400.');
        thumbs.forEach(function (t) { t.classList.toggle('dpdp__thumb--sel', t === th); });
      }
    });
  }

  // ---------- Predictive search ----------
  function initPredictiveSearch() {
    var trigger = document.querySelector('.dh__icon-btn[aria-label="Search"], a[href$="/search"].dh__icon-btn');
    if (!trigger) return;
    if (document.getElementById('dh-search-modal')) return;

    var modal = document.createElement('div');
    modal.id = 'dh-search-modal';
    modal.innerHTML = '<div class="dhs__overlay"></div>'
      + '<div class="dhs__panel">'
        + '<form class="dhs__form" action="/search" method="get" role="search">'
          + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'
          + '<input class="dhs__input" type="search" name="q" placeholder="Search products, courses, articles..." autocomplete="off" autofocus>'
          + '<button type="button" class="dhs__close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>'
        + '</form>'
        + '<div class="dhs__results" hidden></div>'
        + '<div class="dhs__hints">'
          + '<p>Popular: <a href="/collections/courses">Courses</a> <a href="/collections/masks">Masks</a> <a href="/collections/wetsuits">Wetsuits</a> <a href="/pages/travel">Travel</a></p>'
        + '</div>'
      + '</div>';
    var styleEl = document.createElement('style');
    styleEl.textContent = '#dh-search-modal{position:fixed;inset:0;z-index:200;display:none;}'
      + '#dh-search-modal.open{display:block;}'
      + '#dh-search-modal .dhs__overlay{position:absolute;inset:0;background:rgba(1,7,14,.45);}'
      + '#dh-search-modal .dhs__panel{position:absolute;top:0;left:0;right:0;background:#FFFFFF;color:#01070E;padding:24px 32px;max-height:80vh;overflow-y:auto;border-bottom-left-radius:18px;border-bottom-right-radius:18px;animation:dhs-down .25s ease;}'
      + '@keyframes dhs-down{from{transform:translateY(-12px);opacity:0;}to{transform:translateY(0);opacity:1;}}'
      + '#dh-search-modal .dhs__form{display:flex;align-items:center;gap:12px;border-bottom:1px solid rgba(1,7,14,.10);padding:8px 0 16px;color:#01070E;}'
      + '#dh-search-modal .dhs__input{flex:1;border:0;outline:0;font-size:18px;background:transparent;color:#01070E;}'
      + '#dh-search-modal .dhs__close{border:0;background:transparent;cursor:pointer;color:#01070E;width:36px;height:36px;border-radius:50%;display:grid;place-items:center;}'
      + '#dh-search-modal .dhs__close:hover{background:rgba(1,7,14,.08);}'
      + '#dh-search-modal .dhs__results{padding:18px 0 0;}'
      + '#dh-search-modal .dhs__group{margin-bottom:18px;}'
      + '#dh-search-modal .dhs__group h4{font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:rgba(1,7,14,.55);margin:0 0 8px;}'
      + '#dh-search-modal .dhs__row{display:grid;grid-template-columns:48px 1fr auto;gap:14px;align-items:center;padding:8px 4px;border-radius:10px;text-decoration:none;color:#01070E;}'
      + '#dh-search-modal .dhs__row:hover{background:#F4F7FB;}'
      + '#dh-search-modal .dhs__row img{width:48px;height:48px;border-radius:8px;object-fit:cover;background:#F4F7FB;}'
      + '#dh-search-modal .dhs__row .title{font-size:14px;font-weight:600;}'
      + '#dh-search-modal .dhs__row .meta{font-size:12px;color:rgba(1,7,14,.55);}'
      + '#dh-search-modal .dhs__hints{padding:18px 0 0;border-top:1px solid rgba(1,7,14,.10);font-size:13px;color:rgba(1,7,14,.55);}'
      + '#dh-search-modal .dhs__hints a{color:#01070E;text-decoration:underline;margin:0 4px;}'
      + '#dh-search-modal .dhs__empty{padding:24px;text-align:center;color:rgba(1,7,14,.55);font-size:14px;}';
    document.head.appendChild(styleEl);
    document.body.appendChild(modal);

    var input = modal.querySelector('.dhs__input');
    var results = modal.querySelector('.dhs__results');
    var hints = modal.querySelector('.dhs__hints');
    var closeBtn = modal.querySelector('.dhs__close');
    var overlay = modal.querySelector('.dhs__overlay');
    var debounce;

    function open() { modal.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(function(){ input.focus(); }, 50); }
    function close() { modal.classList.remove('open'); document.body.style.overflow = ''; input.value = ''; results.innerHTML = ''; results.hidden = true; hints.hidden = false; }

    if (trigger.tagName === 'A') {
      trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });
    } else {
      trigger.addEventListener('click', function () { open(); });
    }
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; hints.hidden = false; return; }
      hints.hidden = true;
      debounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rs = (data && data.resources && data.resources.results) || {};
            var html = '';
            if ((rs.products || []).length) {
              html += '<div class="dhs__group"><h4>Products</h4>';
              rs.products.forEach(function (p) {
                var img = p.image ? '<img src="' + p.image + '" alt="">' : '<div class="dhs__row-img"></div>';
                html += '<a class="dhs__row" href="' + p.url + '">' + img + '<div><div class="title">' + p.title + '</div><div class="meta">' + (p.product_type || '') + '</div></div><span style="font-size:14px;font-weight:700;">' + p.price + '</span></a>';
              });
              html += '</div>';
            }
            if ((rs.articles || []).length) {
              html += '<div class="dhs__group"><h4>Articles</h4>';
              rs.articles.forEach(function (a) {
                html += '<a class="dhs__row" href="' + a.url + '"><div></div><div><div class="title">' + a.title + '</div><div class="meta">' + (a.summary || '') + '</div></div><span style="font-size:11px;color:rgba(1,7,14,.55);">Article</span></a>';
              });
              html += '</div>';
            }
            if ((rs.pages || []).length) {
              html += '<div class="dhs__group"><h4>Pages</h4>';
              rs.pages.forEach(function (pg) {
                html += '<a class="dhs__row" href="' + pg.url + '"><div></div><div><div class="title">' + pg.title + '</div></div><span style="font-size:11px;color:rgba(1,7,14,.55);">Page</span></a>';
              });
              html += '</div>';
            }
            if (!html) html = '<div class="dhs__empty">No results for "' + q + '". <a href="/search?q=' + encodeURIComponent(q) + '" style="color:inherit;text-decoration:underline;">Search anyway →</a></div>';
            results.innerHTML = html;
            results.hidden = false;
          });
      }, 220);
    });
  }

  // ---------- Sticky header scrolled state ----------
  function initStickyHeader() {
    var header = document.querySelector('.dive-header');
    if (!header) return;
    var threshold = header.classList.contains('dh-floating') ? 80 : 8;
    var ticking = false;
    function update() {
      header.classList.toggle('dh-scrolled', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ---------- Boot ----------
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    bindAtcForms();
    bindCartQtyChange();
    initVariantSwap();
    initPredictiveSearch();
    initStickyHeader();
    refreshCartUI(); // sync count badge in case it was wrong
  });
})();
